export const ResetPasswordForm = {
  ErrorText: 'error-text',
  Password: 'password',
  VerifyPassword: 'verify-password',
  SubmitBtn: 'submit-btn',
} as const;
